import { useState, useContext } from "react";
import { UserContext } from "../../../contexts/userProvider";
import { PatrimonioContext } from "../../../contexts/patrimonioProvider";
import ConsultaTipo from "../Consulta/index";
import TabNavigation from "../../General/TabNavigation";

const Consulta = () => {
  const { setAlert } = useContext(UserContext);
  const { buscarPatrimoniosNfs, buscarPatrimonios, patLoading } = useContext(PatrimonioContext);
  const [editedData, setEditedData] = useState({});
  const [activeTab, setActiveTab] = useState("CONSULTA NOVO");
  const [patrimonioModal, setPatrimonioModal] = useState(false);
  const [patrimonioType, setPatrimonioType] = useState('');

  const handleSearchClick = async () => {
    if (!editedData.id_cliente && !editedData.id_anexo && !editedData.busca) {
      setAlert({ visible: true, title: "Atenção!", placeholder: 'Preencha algum campo para realizar a consulta.', confirm: false, type: "warning" });
      return;
    } else {
      if (activeTab === 'CONSULTA NOVO') {
        let modal = await buscarPatrimoniosNfs(editedData);
        setPatrimonioType('novo');
        setPatrimonioModal(modal);
      } else {
        let modal = await buscarPatrimonios(editedData);
        setPatrimonioType('inventario');
        setPatrimonioModal(modal);
      }
    }
  }

  const tabs = [
    {
      key: 'CONSULTA NOVO',
      label: 'Consulta Novo',
      icon: 'folder',
      content: <ConsultaTipo handleSearchClick={handleSearchClick} editedData={editedData} setEditedData={setEditedData} patrimonioModal={patrimonioModal} setPatrimonioModal={setPatrimonioModal} patrimonioType={patrimonioType} loading={patLoading}/>
    },
    {
      key: 'CONSULTA INVENTÁRIO',
      label: 'Consulta Inventário',
      icon: 'chart',
      content: <ConsultaTipo handleSearchClick={handleSearchClick} editedData={editedData} setEditedData={setEditedData} patrimonioModal={patrimonioModal} setPatrimonioModal={setPatrimonioModal} patrimonioType={patrimonioType} loading={patLoading} />
    }
  ];

  return (
    <div className="w-full">
      <TabNavigation
        tabs={tabs}
        activeTab={activeTab}
        onTabChange={setActiveTab}
        variant="minimal"
      />
    </div>
  );
};

export default Consulta;
